// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__k7xo1"};